import { render, staticRenderFns } from "./FoundersInfo.vue?vue&type=template&id=6bbe17a2&scoped=true&"
import script from "./FoundersInfo.vue?vue&type=script&lang=js&"
export * from "./FoundersInfo.vue?vue&type=script&lang=js&"
import style0 from "./FoundersInfo.vue?vue&type=style&index=0&id=6bbe17a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbe17a2",
  null
  
)

export default component.exports